import React, { useCallback } from 'react';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';
import Button from '../../../../../elements/Button';
import ViewLeadsIcon from './leads.svg';

function ViewLeads(props) {
    const { className = '', eventId } = props,
        i18n = useI18n(),
        href = ['/events', eventId, 'leads'].join('/');

    return (
        <Button className={className} href={href}>
            <ViewLeadsIcon />
            {i18n['label.view-leads']}
        </Button>
    );
}

export default ViewLeads;
